/**
 * @generated SignedSource<<06cfe42bcfba5ca526ee7873a727e775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersStudyStatusChoices = "CM" | "DR" | "LV" | "%future added value";
export type ScreenersStudyTypeChoices = "OO" | "SS" | "SY" | "%future added value";
export type LaunchStudyInput = {
  clientMutationId?: string | null;
  studyId: string;
};
export type ProjectPage_LaunchStudy_Mutation$variables = {
  input: LaunchStudyInput;
};
export type ProjectPage_LaunchStudy_Mutation$data = {
  readonly launchStudy: {
    readonly study: {
      readonly dId: any | null;
      readonly id: string;
      readonly name: string | null;
      readonly screener: {
        readonly elementTypeCounts: ReadonlyArray<{
          readonly count: number;
          readonly elementType: string;
        } | null>;
      } | null;
      readonly status: ScreenersStudyStatusChoices;
      readonly tenant: {
        readonly dId: any | null;
        readonly name: string;
        readonly vpmAccountId: number | null;
      };
      readonly type: ScreenersStudyTypeChoices;
    } | null;
  } | null;
};
export type ProjectPage_LaunchStudy_Mutation = {
  response: ProjectPage_LaunchStudy_Mutation$data;
  variables: ProjectPage_LaunchStudy_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ScreenerElementType",
  "kind": "LinkedField",
  "name": "elementTypeCounts",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elementType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vpmAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectPage_LaunchStudy_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LaunchStudyPayload",
        "kind": "LinkedField",
        "name": "launchStudy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPage_LaunchStudy_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LaunchStudyPayload",
        "kind": "LinkedField",
        "name": "launchStudy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "259bb882cb8954fd9da22cc2cf358f72",
    "id": null,
    "metadata": {},
    "name": "ProjectPage_LaunchStudy_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProjectPage_LaunchStudy_Mutation(\n  $input: LaunchStudyInput!\n) {\n  launchStudy(input: $input) {\n    study {\n      dId\n      id\n      name\n      status\n      type\n      screener {\n        elementTypeCounts {\n          elementType\n          count\n        }\n        id\n      }\n      tenant {\n        dId\n        vpmAccountId\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "384c762b737ade6ae6081927908ea95c";

export default node;
